import styled from 'styled-components';
import Card from 'components/generic/card';
import { Button } from 'components/Button';
import { StripedVerticalSpacer } from 'components';
import { Typography } from 'components/generic/typography';
import isClient from 'helpers/isClient';
import { useTranslation } from 'react-i18next';
import { OK } from 'autogen/translation-keys/trans-website-shared';

export type CookieInfoboxProps = {
    headline: string;
    body: string;
    callback?: () => void;
};

const StyledCard = styled(Card)`
    width: 264px;
`;

const Grid = styled.div`
    display: grid;
    gap: 16px;
`;

const StyledButton = styled(Button)`
    width: 100%;
`;

function CookieInfobox(props: CookieInfoboxProps) {
    const { headline, body, callback } = props;
    const { t } = useTranslation();

    const onClick = () => {
        if (isClient && (window as any).CookieConsent) {
            (window as any).CookieConsent.show();
        }

        callback?.();
    };

    return (
        <StyledCard>
            <Card.Content>
                <Grid>
                    <Typography.Headline size="S">{headline}</Typography.Headline>
                    <Typography.Body as="span" size="S">
                        {body}
                    </Typography.Body>

                    <StyledButton size="sm" onClick={onClick}>
                        {t(OK)}
                    </StyledButton>
                </Grid>
            </Card.Content>
        </StyledCard>
    );
}

export default CookieInfobox;
